import { render } from "./ImageRichText.vue?vue&type=template&id=31ecf141&scoped=true"
import script from "./ImageRichText.vue?vue&type=script&lang=js"
export * from "./ImageRichText.vue?vue&type=script&lang=js"

import "./ImageRichText.vue?vue&type=style&index=0&id=31ecf141&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ecf141"]])

export default __exports__